/**
 * Custom file, adding metadata prop
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';
import { PAGES_METADATA } from 'shared/custom/constants/commonConstants';

export const getHomePage = (props: IncomingContent): Layout => ({
	name: 'DoubleStack',
	metadata: PAGES_METADATA.HOMEPAGE,
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: getContentItemForSlot(props, 'first'),
		second: getContentItemForSlot(props, 'second'),
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
